import React, { FC, memo } from "react";
import { ButtonColor } from "enums/Button";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import { UndoText, UndoWrapper } from "./Undo.styles";

interface UndoProps {
  text: string;
  onClick: () => void;
  className?: string;
}

const Undo: FC<UndoProps> = ({ text, onClick, className = "" }) => {
  const { t } = useTranslation("common");

  return (
    <UndoWrapper className={className}>
      <UndoText>{text}</UndoText>
      <Button color={ButtonColor.Primary} onClick={onClick}>
        {t("common.undo")}
      </Button>
    </UndoWrapper>
  );
};

export default memo(Undo);
